import React from "react"
import { Navigate } from "react-router-dom"

import { FEATURES_TYPE } from "@constants"
import { AUTO_EUROPE_TOOL_ROUTES } from "@constants/routes"
import AppLayout from "Layout"
import AutoEuropePricingToolPage from "Pages/AutoEuropeTool/Page"
import AutoEuropePricingIdPage from "Pages/AutoEuropeTool/PricingId"
import AutoEuropeProviderNormalizationPage from "Pages/AutoEuropeTool/ProviderNormalization"
import AutoEuropeNotificationsPage from "Pages/AutoEuropeTool/Notifications"
import AutoEuropeCheckersPage from "Pages/AutoEuropeTool/Checkers"
import AutoEuropeSeasonSetsPage from "Pages/AutoEuropeTool/SeasonSets"

export const AutoEuropeToolRoutes = userData => {
	if (!userData?.featuresV2?.autoeurope) return []

	return [{
		id: FEATURES_TYPE.AUTOEUROPE,
		path: AUTO_EUROPE_TOOL_ROUTES.PATH,
		title: AUTO_EUROPE_TOOL_ROUTES.TITLE,
		icon: 'euro-sign',
		element: <AppLayout/>,
		children: [
			{ element: <Navigate to={AUTO_EUROPE_TOOL_ROUTES.CONFIGURATION_PATH} replace/>, index: true },
			{
				path: AUTO_EUROPE_TOOL_ROUTES.CONFIGURATION_PATH,
				title: AUTO_EUROPE_TOOL_ROUTES.CONFIGURATION_TITLE,
				element: <AutoEuropePricingToolPage/>,
			},
			{
				path: AUTO_EUROPE_TOOL_ROUTES.PRICING_ID_PATH,
				title: AUTO_EUROPE_TOOL_ROUTES.PRICING_ID_TITLE,
				element: <AutoEuropePricingIdPage/>,
			},
			{
				path: AUTO_EUROPE_TOOL_ROUTES.PROVIDER_NORMALIZATION_PATH,
				title: AUTO_EUROPE_TOOL_ROUTES.PROVIDER_NORMALIZATION_TITLE,
				element: <AutoEuropeProviderNormalizationPage/>,
			},
			{
				path: AUTO_EUROPE_TOOL_ROUTES.CHECKERS_PATH,
				title: AUTO_EUROPE_TOOL_ROUTES.CHECKERS_TITLE,
				element: <AutoEuropeCheckersPage/>,
			},
			{
				path: AUTO_EUROPE_TOOL_ROUTES.NOTIFICATIONS_PATH,
				title: AUTO_EUROPE_TOOL_ROUTES.NOTIFICATIONS_TITLE,
				element: <AutoEuropeNotificationsPage/>,
			},
			{
				path: AUTO_EUROPE_TOOL_ROUTES.SEASON_SETS_PATH,
				title: AUTO_EUROPE_TOOL_ROUTES.SEASON_SETS_TITLE,
				element: <AutoEuropeSeasonSetsPage/>,
			},
		]
	}]
}